/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Tabs,
  Tab,
  Box,
  Typography,
  makeStyles,
  styled,
} from "@material-ui/core";
import UserTable from "./Users/UserTable";
import GroupsTable from "./Groups/GroupsTable";
import RolesTable from "./Roles/RolesTable";
import Actions from "../../fluid/Actions/ActionFactory";
import ErrorMessageAlert from "../Utilities/ErrorMessageAlert";

const useStyles = makeStyles(() => ({
  tab: {
    color: "#3582F6",
    textTransform: "none",
    fontSize: "17px",
  },
}));
const AntTabs = styled(Tabs)({
  "& .MuiTabs-indicator": {
    backgroundColor: "#127DFC",
  },
});
const AntTab = styled((props) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    fontSize: "17px",
    color: "#3582F6",
    "&:hover": {
      color: '"#3582F6"',
      opacity: 1,
    },
    "&.Mui-selected": {
      color: "#3582F6",
    },
  })
);

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`user-tabpanel-${index}`}
      aria-labelledby={`user-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `user-tab-${index}`,
    "aria-controls": `user-tabpanel-${index}`,
  };
}

const DataPanel = ({
  toggle,
  setToggle,
  selectedData,
  setSelectedData,
  isNew,
  setIsNew,
  menuType,
  setMenuType,
  isTableUpdated,
  setIsTableUpdated,
  deleted,
  setdeleted,
  isCreate,
  newdata,
  setisCreate,
}) => {
  console.log("table......", isTableUpdated);
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [UserData, setUserData] = useState(null);
  const [GroupData, setGroupData] = useState(null);
  const [RoleData, setRoleData] = useState(null);
  const [error, seterror] = useState(false);
  const [errmsg, seterrmsg] = useState(null);

  useEffect(() => {
    Actions("http_request", {
      url: "/sainapse/" + menuType,
      method: "get",
    })
      .then((res) => {
        console.log("res..", res.data);
        if (menuType === "user") {
          setUserData(res?.data);
          setIsTableUpdated(false);
        } else if (menuType === "group") {
          setGroupData(res?.data);
          setIsTableUpdated(false);
        } else if (menuType === "role") {
          setRoleData(res?.data);
          setIsTableUpdated(false);
        }
      })
      .catch((err) => {
        console.log("err..", err.message);
        seterror(true);
        seterrmsg(err);
      });
  }, [menuType, isTableUpdated]);

  useEffect(() => {
    if (value === 0) {
      setMenuType("user");
    } else if (value === 1) {
      setMenuType("group");
    } else if (value === 2) {
      setMenuType("role");
    }
    setToggle(false);
    setIsNew(false);
  }, [value]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const closeError = () => {
    seterror(false);
    seterrmsg(null);
  };
  return (
    <Box data-testid="temp" sx={{ width: "100%" }}>
      <Box style={{ background: "#FFFFFF", border: "1px solid #0000001F" }}>
        <AntTabs value={value} onChange={handleChange}>
          <AntTab label="Users" {...a11yProps(0)} />
          <AntTab label="Groups" {...a11yProps(1)} />
          <AntTab label="Roles" {...a11yProps(2)} />
        </AntTabs>
      </Box>
      <TabPanel value={value} index={0} data-testid="usertable">
        <UserTable
          data={UserData}
          toggle={toggle}
          setToggle={setToggle}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          isNew={isNew}
          setIsNew={setIsNew}
          setMenuType={setMenuType}
          deleted={deleted}
          setdeleted={setdeleted}
          isCreate={isCreate}
          newdata={newdata}
          setisCreate={setisCreate}
        />
      </TabPanel>
      <TabPanel value={value} index={1} data-testid="grouptable">
        <GroupsTable
          data={GroupData}
          toggle={toggle}
          setToggle={setToggle}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          isNew={isNew}
          setIsNew={setIsNew}
          setMenuType={setMenuType}
          deleted={deleted}
          setdeleted={setdeleted}
          isCreate={isCreate}
          newdata={newdata}
          setisCreate={setisCreate}
        />
      </TabPanel>
      <TabPanel value={value} index={2} data-testid="roletable">
        <RolesTable
          data={RoleData}
          toggle={toggle}
          setToggle={setToggle}
          selectedData={selectedData}
          setSelectedData={setSelectedData}
          isNew={isNew}
          setIsNew={setIsNew}
          setMenuType={setMenuType}
          deleted={deleted}
          setdeleted={setdeleted}
          isCreate={isCreate}
          newdata={newdata}
          setisCreate={setisCreate}
        />
      </TabPanel>
      {error && (
        <ErrorMessageAlert
          open={error}
          handleClose={closeError}
          errorInfo={errmsg}
        />
      )}
    </Box>
  );
};
export default DataPanel;
